import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Experience from './pages/Experience';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProjectDisplay from './pages/ProjectDisplay';
import Coontact from './pages/Coontact';
function App() {
  return (
    <div className="App">
      <Router>
      <Navbar/>
        <Routes>          
          <Route path="" element={<Home/>}/>
          <Route path="/experience" element={<Experience/>}/>
          <Route path="/projects" element={<Projects/>}/>
          <Route path="/projects/:id" element={<ProjectDisplay/>}/>
          <Route path="/contact" element={<Coontact/>}/>
          
        </Routes>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
